import React from 'react';
import LoadingSpinner from '../../static/dashboard/loadingspinner.svg';
import WhiteLoadingSpinner from '../../static/dashboard/whiteloadingspinner.svg';
import Complete from '../../static/dashboard/blackcomplete.svg';
import WhiteComplete from '../../static/dashboard/complete.svg';
/* 
    Props:
    loading - loading boolean
    loaded - loaded boolean
    defaultText - text to show when neither loading/loaded
    loadingText - text so who when loading
    loadedText - text to show when loaded
    classes - any custom css classes (space separated)
    theme - what color the text and icons (i.e. loading and loaded) should be (current options: 'white' and 'black')
*/
export default function LoadButton({ loading, loaded, defaultText, loadingText, loadedText, classes, theme, handleClick, disabled }) {
    return (
        <button
        onClick={(e) => {
            if (handleClick) {
                handleClick();
            }
        }} 
        type="submit" 
        className={`${classes} ${disabled ? 'disabled-button' : ''} ${(loaded || loading) ? "no-click" : ""}`}>
        {
            loading 
            ?
                <><img src={theme === 'black' ? LoadingSpinner : WhiteLoadingSpinner} alt="Loading"/>{loadingText}</>
            : (
            loaded 
            ? 
                <><img className="check-img" src={theme === 'black' ? Complete : WhiteComplete} alt="Complete"/>{loadedText}</>
            :   defaultText
            )
        }
        </button>
    )
}